import * as React from 'react'
import * as TT from '../../components/ChartToolTip'

interface Props {
  from: string
  to: string
  valueLabel: string | React.ReactElement
}

export const ToolTip: React.FC<Props> = ({ from, to, valueLabel }) => {
  return (
    <TT.Container>
      <TT.TipHead>
        <TT.Left>$label</TT.Left>
        <TT.Right>{new Date(from).toLocaleString('default', { month: 'short' })} {new Date(from).getFullYear()} - {new Date(to).toLocaleString('default', { month: 'short' })} {new Date(to).getFullYear()}</TT.Right>
      </TT.TipHead>
      <TT.ValueLabel>{valueLabel}</TT.ValueLabel>
      <TT.Value>$datavalue</TT.Value>
    </TT.Container>
  )
}
